function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback } from 'react';
export var createEventChannelBridgeFactory = function createEventChannelBridgeFactory(eventChannelFactory, sendPayloadCallack) {
  return function () {
    var eventChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventChannelFactory();
    var Bridge = function Bridge(_ref) {
      var client = _ref.client,
        children = _ref.children;
      return /*#__PURE__*/React.createElement(eventChannel.Listener, {
        onEvent: useCallback(function (payload) {
          sendPayloadCallack(client, payload);
          return payload;
        }, [client])
      }, children);
    };
    return {
      /**
       * @internal
       * Used by integration packages
       */
      eventChannel: eventChannel,
      Bridge: Bridge
    };
  };
};
export var withClient = function withClient(client, Component) {
  return function (_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React.createElement(Component, {
      client: client
    }, children);
  };
};
export var combineBridges = function combineBridges() {
  for (var _len = arguments.length, bridges = new Array(_len), _key = 0; _key < _len; _key++) {
    bridges[_key] = arguments[_key];
  }
  var CombinedSendEvents = function CombinedSendEvents(_ref3) {
    var children = _ref3.children,
      client = _ref3.client;
    var wrappedChildren = children;
    for (var _i = 0, _bridges = bridges; _i < _bridges.length; _i++) {
      var _SendEventsComponent = _bridges[_i];
      wrappedChildren = _SendEventsComponent({
        client: client,
        children: wrappedChildren
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, wrappedChildren);
  };
  return CombinedSendEvents;
};

// TODO: Better types
export var renderCombined = function renderCombined(children, components) {
  var wrappedChildren = children;
  var _iterator = _createForOfIteratorHelper(components),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var Component = _step.value;
      wrappedChildren = /*#__PURE__*/React.createElement(Component, null, wrappedChildren);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return wrappedChildren;
};